import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AuditResult } from '@/lib/schemas';

interface RecommendationsListProps {
  result: AuditResult;
  recommendations: string[];
}

export function RecommendationsList({ result, recommendations }: RecommendationsListProps) {
  return (
    <>
      <Card className="mb-6 border-0 shadow-xl bg-white/90 backdrop-blur-sm">
      <CardHeader className="pb-4">
        <CardTitle className="text-2xl md:text-3xl font-extrabold tracking-tight text-gray-900">
          <span className="bg-gradient-to-r from-brand-orange to-orange-500 bg-clip-text text-transparent">
            Your Quick Wins (ranked by impact)
          </span>
          <p className="mt-2 text-sm text-gray-500">
            We'll pick 2 in the call and outline next steps.
          </p>
          {typeof result.min_annual_savings === 'number' && typeof result.max_annual_savings === 'number' && typeof result.total_staff_assumed === 'number' && (
            <div className="mt-6 p-5 md:p-6 rounded-2xl border border-brand-orange/30 bg-gradient-to-br from-white via-orange-50/60 to-orange-100/50 shadow-lg">
              <h3 className="text-xs font-semibold tracking-widest text-brand-orange uppercase flex items-center gap-2">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-brand-orange animate-pulse"></span>
                Estimated annual savings ($)
              </h3>
              <div className="mt-2 flex items-baseline gap-2">
                <span className="text-2xl md:text-3xl font-extrabold text-gray-900">
                  {'$'}{result.min_annual_savings.toLocaleString()}–{result.max_annual_savings.toLocaleString()}
                </span>
                <span className="text-sm font-semibold text-gray-500">/yr</span>
              </div>
              <p className="font-semibold mt-1 text-xs md:text-sm text-gray-500">
                Example ({result.total_staff_assumed} staff, admin work)              
              </p>
              <p className="font-semibold mt-1 text-xs md:text-sm text-gray-500">
                Plus saving on paper, printing and unused software
              </p>
            </div>
          )}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {recommendations.slice(0, 6).map((recommendation, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-xl border border-gray-200 bg-white/80 backdrop-blur-sm p-4 md:p-5 pl-6 md:pl-7 shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-0.5"
            >
              <div className="absolute left-0 top-0 h-full w-1.5 bg-gradient-to-b from-brand-orange to-orange-500" />
              <div className="pointer-events-none absolute -right-10 -top-10 h-24 w-24 rounded-full bg-orange-200/40 blur-2xl transition-colors duration-300 group-hover:bg-orange-200/60" />
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-7 h-7 rounded-full bg-gradient-to-br from-brand-orange to-orange-500 text-white flex items-center justify-center text-xs font-extrabold shadow-md ring-1 ring-orange-400/40 transition-transform duration-300 group-hover:scale-105">
                  {index + 1}
                </div>
                <p className="text-sm md:text-base text-gray-800 leading-relaxed">
                  {recommendation}
                </p>
              </div>
            </div>
          ))}
        </div>
        </CardContent>
      </Card>
    </>
  );
}